import {useCallback, useState} from 'react';
import type {EditorStepState} from '../../../../containers/landing-page-studio/landing-page-studio';
import {Step6Preview} from '../step6-preview';

export const useCreateStep6Preview = () => {
  const [editorState, setEditorState] = useState<EditorStepState>({
    isSaving: false,
    isLogoPoolEmpty: false,
    variantsCount: 0,
  });

  const component = useCallback(
    () => <Step6Preview onEditorStateChange={setEditorState} />,
    []
  );

  return {
    component,
    editorState,
  };
};
